import { create } from "zustand";

/**
 * Autosave lifecycle for the resume builder.
 *
 * - `idle`    nothing has been edited this session
 * - `saving`  an edit is debounced or in flight
 * - `saved`   the server acknowledged the latest edit
 * - `error`   the last save failed; changes exist only in memory
 */
export type SaveStatus = "idle" | "saving" | "saved" | "error";

type SaveStatusStore = {
  status: SaveStatus;
  lastSavedAt: Date | null;

  setStatus: (status: SaveStatus) => void;
  setSaved: () => void;
  reset: () => void;
};

export const useSaveStatusStore = create<SaveStatusStore>()((set) => ({
  status: "idle",
  lastSavedAt: null,

  setStatus: (status) => {
    set({ status });
  },
  setSaved: () => {
    set({ status: "saved", lastSavedAt: new Date() });
  },
  reset: () => {
    set({ status: "idle", lastSavedAt: null });
  },
}));
